/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

/**
 * Another entry point for webpack. This webpack bundle gets shared/used in both proteus and vue app.
 */

import pixelTracking from "@/service/pixelTracking"
import PDFReport from "@/service/pdfreport"
import zendesk from "@/service/zendesk"

zendesk()
pixelTracking()
window.PDFReport = PDFReport



// WEBPACK FOOTER //
// ./src/entries/shared.js